import styles from "./HeaderDescription.module.css";

interface HeaderDescriptionProps {
  description?: string;
}

export default function HeaderDescription({
  description,
}: HeaderDescriptionProps): JSX.Element {
  return <div className={styles.description}>{description}</div>;
}
